import { useState } from "react";
import { ISkill } from "../hardSkillsData";
import Collapsible from "react-collapsible";
import styles from "./style.module.scss";
import { MdArrowDownward } from "react-icons/md";

interface IHardSkillProps {
   hardSkill: ISkill;
}

export default function HardSkillCard({ hardSkill }: IHardSkillProps) {
   const [isOpen, setIsOpen] = useState(false);

   return (
      <li className={styles.hardSkillCard}>
         <Collapsible
            trigger={
               <div
                  className={`${styles.collapseTrigger} ${isOpen ? styles.active : ""}`}
                  onClick={() => setIsOpen((isOpen) => !isOpen)}
               >
                  <div>
                     <h3 className="title four dark">{hardSkill.title}</h3>
                     {hardSkill.tag ? <span className={styles.tag}>{hardSkill.tag}</span> : null}
                  </div>

                  <div>
                     <MdArrowDownward />
                  </div>
               </div>
            }
         >
            <div className={styles.collapseContent}>
               <p className="paragraph white">{hardSkill.description}</p>
            </div>
         </Collapsible>
      </li>
   );
}
